__turbopack_context__.v({
  "btn__close": "VuEo4G_btn__close",
  "fade-in": "VuEo4G_fade-in",
  "membership_success_popup": "VuEo4G_membership_success_popup",
  "passport_compass": "VuEo4G_passport_compass",
  "vanish": "VuEo4G_vanish",
});
